import React from "react";
import TeamCommon from "../Team/TeamMain";
import { membersData } from "../mockdata";
import { columnHeader } from "../Team/teamConfig";

const Team = () => (
  <TeamCommon
    data={membersData}
    title="User Access Members"
    columnHeader={columnHeader}
  />
);

export default Team;
